module.exports = __webpack_public_path__ + "static/media/LP_ReadMore.ce922433.svg";